var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"day-of-week mt-1"},_vm._l((_vm.weekdays),function(weekday){return _c('div',{key:weekday},[_vm._v(_vm._s(weekday))])}),0),_c('el-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }